import React from "react";

const NavButtons = () => {
  return (
    <div className="nav-buttons">
      {/*			<img src={backButton} alt="" onClick={() => dispatch(decrementPage())}/>
			<img src={forwardButton} alt="" onClick={() => dispatch(incrementPage())} /> */}
    </div>
  );
};

export default NavButtons;
